import React from 'react';
import classnames from 'classnames';
import { node, string } from 'prop-types';
import { HEADER_SOURCE, PACKAGE_CLASSNAME } from '../../../constants';
import { DEFAULT_STYLE, LINK_CLASSNAME, LINK_TITLE_CLASSNAME } from '../constants';
import { useHeaderContext } from '../../../modern/context/HeaderContext';

const LanguageLink = ({ style = DEFAULT_STYLE, className, Component }) => {
    const { locale, displayedLocale, supportedLanguages, user, abTests, rollouts } = useHeaderContext();
    const props = {
        locale,
        displayedLocale,
        supportedLanguages,
        user,
        style,
        className: classnames(LINK_CLASSNAME, className),
        titleClassName: LINK_TITLE_CLASSNAME,
        modalClassName: PACKAGE_CLASSNAME,
        source: HEADER_SOURCE,
        abTests,
        rollouts,
    };

    return <Component {...props} />;
};

LanguageLink.propTypes = {
    className: string,
    style: string,
    Component: node.isRequired,
};

export default LanguageLink;
